import { GET_ALL_ACADEMICQUOTA } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_ACADEMICQUOTA:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getAcademicQuotaDetailsByStudentId.js